const ButtonLoader = {
  start: (button: HTMLElement): void => {
    button.classList.add('loading', 'disabled')
    button.setAttribute('disabled', 'disabled')
  },

  reset: (button: HTMLElement): void => {
    button.classList.remove('loading', 'disabled', 'success')
    button.removeAttribute('disabled')
  },

  success: (button: HTMLElement): void => {
    button.classList.remove('loading', 'disabled')
    button.classList.add('success')
    button.removeAttribute('disabled')

    setTimeout(() => {
      button.classList.remove('success')
    }, 1500)
  },
}

export default ButtonLoader
